<template>
  <section :class="title ? 'with-title' : ''">
    <h2 v-if="title">{{title}}</h2>

    <ServicesOrigami 
      animal="cock" />

    <aside
        v-for="issue in accessibilityIssues"
        :key="issue.id">
      <!-- <Screen
        :type="'full'" /> -->

      <DataGrid 
        v-if="isService"
        :number="22890"
        :icon="issue.icon"
        :title="issue.title"/>

      <DataGrid
        v-else
        :bg="issue.color"
        :icon="issue.icon"
        :title="issue.title"
        :text="issue.text" />
    </aside>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
// import Screen from '@/components/Screen.vue'
import DataGrid from '@/components/widgets/data-grid/DataGrid.vue'
import ServicesOrigami from '../../origami/ServicesOrigami'

export default {
  name: 'accessibility-container',
  props: ['type', 'title'],
  components: {
    DataGrid,
    ServicesOrigami
    // Screen
  },
  computed: {
    ...mapGetters({
      accessibilityIssues: 'accessibilityIssues'
    }),
    isService: function() {
      return this.type === 'service'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_mixins.scss';

  section {
    @include grid-padding;
    @include grid-container;
    background: white;
    position: relative;

    @include respond-to(tablet) {
    @include vertical-padding;
      @include grid(2);
      grid-gap: $small_vmin;
    }   

    @include respond-to(desktop) {
      @include grid(3);
      grid-gap: $small_vmin;
      padding-right: 10vmin;
      padding-left: 10vmin;
    }  

    // @include respond-to(tv) {
    //   display: grid;
    //   grid-template-columns: repeat(6, 1fr);
    // }  

    >figure {

      @include respond-to(tablet) {
        max-width: 17vw;
        transform: scale(1.35);
      }  

      @include respond-to(desktop) {
        transform: scale(1.25);
      }  

      @include respond-to(tv) {
        max-width: 12vw;
        transform: translate($default_vmin, $big_vmin) scale(1.5);
      }  
    }

    aside {
      &:not(:first-of-type) {
        margin: $default_vmin 0;

        @include respond-to(tablet) {
          margin: 0;
        }   
      }
      
      figure {
        max-width: 100%;
        margin: 0;
      }
    }
  }
  
</style>
